var React = require('react');

function EyeCrossedInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25 10.9001C25 10.9001 21.4 18.1001 13 18.1001C4.6 18.1001 1 10.9001 1 10.9001C1 10.9001 4.6 3.70007 13 3.70007C21.4 3.70007 25 10.9001 25 10.9001Z","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round","key":0}),React.createElement("circle",{"cx":"13","cy":"10.9","r":"3.6","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M2.19995 21.7L22.5999 1.30005","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round","key":2})]);
}

EyeCrossedInline.defaultProps = {"viewBox":"0 0 26 23","fill":"none"};

module.exports = EyeCrossedInline;

EyeCrossedInline.default = EyeCrossedInline;
